import Link from "next/link";
import { Breadcrumbs, Typography } from "@mui/material";

export default function CategoryBreadcrumb({ category }: { category: string }) {
  // Convert slug → Capitalized text
  const readable = category?.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ mb: 1 }}>
      <Link href="/" style={{ textDecoration: "none", color: "#555" }}>
        Home
      </Link>

      <Typography color="text.primary" sx={{ textTransform: "capitalize" }}>
        {readable}
      </Typography>
    </Breadcrumbs>
  );
}
